import React from "react";
import {
  Button,
  IDropzoneUploaderFile,
  Popup,
  SelectFormik,
} from "component-library";
import { dataTestIds } from "data-testids";

import { JoiningPage } from "translations/src/models/joining-pages";
import { useTranslations } from "../../../../../hooks/useTranslations";
import { usePhotographerNameOptions } from "../../../../../hooks/usePhotographerName";
import JoiningFormTooltip, {
  getTootlipProps,
} from "../../../Common/JoiningFormTooltip";

interface IUploadImageModalProps {
  image: IDropzoneUploaderFile;
  onSavePhotoData: () => void;
  closeModal: () => void;
  disableSubmit: boolean;
  isYP?: boolean;
}

const UploadImageModal: React.FC<IUploadImageModalProps> = ({
  image,
  onSavePhotoData,
  closeModal,
  disableSubmit,
  isYP,
}) => {
  const { texts } = useTranslations(JoiningPage.AboutYouPage);
  const pageTexts = texts.uploadModal;
  const pageTooltipText = texts.aboutYouFormTooltips;

  const imageUrl = URL.createObjectURL(image.file);

  const { getPhotographerNameOptions } = usePhotographerNameOptions();

  return (
    <Popup
      width={{ lg: 7, md: 10 }}
      close={closeModal}
      priority="high"
      texts={{
        closePopup: pageTexts.cancelPhotoLabel,
      }}
      fullHeight
    >
      <div className="g-popup-content">
        <div className="g-popup-content__header">{pageTexts.uploadTitle}</div>
        <div className="g-popup-content__scrollable">
          <main className="flex flex-col p-3 pb-6 space-y-4">
            <section className="flex justify-center bg-color-neutral-three">
              <img
                src={imageUrl}
                alt={pageTexts.uploadedImageAltText}
                className="h-full max-h-60"
                style={{ minHeight: 200 }}
              />
            </section>

            <div>
              <SelectFormik
                name="photographerName"
                label={pageTexts.photographerNameLabel}
                searchableByInput
                canCreateOptions
                noOptionsText={pageTexts.photographerNameLabel}
                options={getPhotographerNameOptions}
                maxAmountOfOptionsBeforeScroll={4}
                tooltipComponent={() => (
                  <JoiningFormTooltip
                    tooltipProps={getTootlipProps(
                      pageTooltipText.photographerNameTooltipHeader,
                      pageTooltipText.photographerNameTooltipBody
                    )}
                  />
                )}
                isClearable
              />
            </div>
            <div className="h-24" />
          </main>
        </div>

        <hr className="g-split-line" />
        <div className="flex flex-col p-3 space-y-2">
          <div>
            <Button
              type="primary"
              text={pageTexts.choosePhotoLabel}
              onClick={() => onSavePhotoData()}
              loading={disableSubmit}
              id={`btn${isYP ? "-yp" : ""}-headshot-choose-photo`}
              data-testid={
                dataTestIds.joiningPages[
                  "JoiningPages.Performers.UploadImageModal.choosePhotoButton"
                ]
              }
            />
          </div>
          <div>
            <Button
              type="secondary"
              text={pageTexts.cancelPhotoLabel}
              onClick={closeModal}
              id={`btn${isYP ? "-yp" : ""}-headshot-back`}
            />
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default UploadImageModal;
